import React, { Component } from 'react'
import { connect } from 'react-redux';

import { reduxForm, change } from 'redux-form';

import {AddDiningLocation, UpdateDiningLocation, DeleteDiningLocation} from '../../actions/diningLocationActions'

import { Modal, Grid, TextField } from '@material-ui/core';

import { InfoOutlined } from '@material-ui/icons';
import { sweetAlert } from '../../components/Alert/sweetAlert';
import DeleteDiningLocationModal from './DeleteDiningLocationModal';


const validate = (values) => {
    const errors = {};

    if (!values.name) {
        errors.name='Please write the name of the dining location'

    }else if(values.name.length>30){
        errors.name='The name of the dining location must be less than 30 characters'

    }

    return errors;
};


class AddEditDiningLocation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            _id:(props.data?._id)? props.data._id : undefined,
            name:(props.data?.name)? props.data.name : '',
            openDeleteModal:false,
        };
        
        if (props.data) {

            this.props.dispatch(change('DiningLocationForm', '_id', props.data._id ? props.data._id : ''));
            this.props.dispatch(change('DiningLocationForm', 'name', props.data.name ? props.data.name : ''));

        } else {
            this.props.dispatch(change('DiningLocationForm', '_id', ''));
            this.props.dispatch(change('DiningLocationForm', 'name', ''));
        }
    }
    

    CheckValues=(name)=>{
        if(this.props.data){

            if(name && name!=='' && name!==this.props.data.name && name.length<=30){
                (this.props.buttonState) && this.props.enableButton();
            }else{
                (!this.props.buttonState)&& this.props.disableButton();
            }

        }else{

            if( name!=='' && name.length<=30){
                (this.props.buttonState) && this.props.enableButton();
            }else{
                (!this.props.buttonState) && this.props.disableButton();
            }
        }
    }

    handleDelete=()=>{

        if(this.props.data){

            this.setState({
                openDeleteModal:true,
    
            })
        }

      
    }

    handleDeleteDiningLocation=()=>{
        if(this.props.data){
            this.props.DeleteDiningLocation(this.props.data._id);
        }

        this.props.close();
    }

    
    handleSubmit=()=>{

        if(!this.state.name || this.state.name===''){
            sweetAlert('error','Please write the name of the dining location');
            return;
        }

        if(this.state.name.length>30){
            sweetAlert('error','The name of the dining location must have less than 30 characters');
            return;
        }

        const obj = {
            name:this.state.name,
            communityId:localStorage.getItem('communityId'),
        }

        if(this.props.data){ //update

            obj._id=this.state._id
            this.props.UpdateDiningLocation(this.props.data._id, obj);

        }else{ //add
            this.props.AddDiningLocation(obj);
        }

        this.props.close();
    }
    
    

    render() {
        return (
            <>
                <div className="imgalignrigth-engage appbtn-details-engage">
                    <div id="save_dining_location_btn" className="appbtn-engage skybluebtn-engage" onClick={this.handleSubmit}>
                        Save
                    </div>
                    <div id="delete_dining_location_btn" className="appbtn-engage redbtn-engage" onClick={this.handleDelete}>
                        Delete
                    </div>
                </div>

                <form>
                    <Grid item container xs={12} style={{padding:'20px'}} alignItems='flex-start'>
                        {/* General Info */}
                        <Grid item container xs={12} sm={6} md={6} lg={4} style={{paddingRight:'1.5rem'}}>
                            <Grid item xs={12} className='setUpTitleEngage' >
                                General Info
                            </Grid>

                            <Grid item container xs={12} className="setUpGridColum">
                                <Grid item xs={12}>
                                    <TextField
                                        name="name"
                                        label="Name"
                                        fullWidth
                                        placeholder='Dining Location Name'
                                        onChange={({target}) => this.setState({ name: target.value }, ()=>this.CheckValues(target.value))}
                                        id='Dining_location_name'
                                        value={this.state.name}
                                        error={this.state.name.trim()==='' || this.state.name.length>30}
                                        helperText={this.state.name.trim()===''?'Please write the name of the dining location' : this.state.name.length>30? 'The dining location name must have less than 30 characters':''}
                                    />

                                    <Grid item container alignContent='center' justifyContent='flex-end' style={{paddingRight:'15px'}}>
                                        {
                                            (this.state?.name?.length > 0)?
                                            <Grid item> {`${this.state.name.length}/30`}</Grid>
                                            :
                                            undefined
                                        }
                                    </Grid> 
                                </Grid>

                            </Grid>
                        
                        </Grid>

                        {/* Icon */}
                        <Grid item container xs={12} sm={6} md={6} lg={4}>
                            <Grid item xs={12} className='setUpTitleEngage' >
                                Icon
                            </Grid>

                            <Grid item container xs={12} className="setUpGridColum">
                                <Grid item container xs={12} justify='center'>
                                    {
                                        this.state.name && this.state.name.trim()!==''?
                                        <Grid style={{fontFamily:'Gotham-Book', fontSize:'100px'}}>{this.state.name.trim().length>0? this.state.name.charAt(0).toUpperCase():''}</Grid>
                                        :
                                        <img
                                            src='https://engage360.s3.amazonaws.com/Icons/Categories/question-circle.svg'
                                            width='120px'
                                            alt='Location'
                                            height='120px'
                                            style={{opacity:'56%'}}
                                        />
                                    }
                                   
                                </Grid>
                            
                            </Grid>

                            <Grid item container xs={12} style={{marginTop:'1rem'}}>

                                <Grid item xs={1}>
                                    <InfoOutlined fontSize='large'/>
                                </Grid>
                                <Grid item xs={11} style={{color:"#F0EFEF", opacity:"0.56", fontFamily:"Gotham-Book", fontSize:"20px", paddingLeft:'1rem'}}>
                                    The icon is used to distinguish the different dining locations on the residents TV's.
                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>

            
                    <Modal
                        open={this.state.openDeleteModal}
                        onClose={() =>this.setState({ openDeleteModal: false })}
                    >
                        <DeleteDiningLocationModal
                            location={this.props.data}
                            close={() =>this.setState({ openDeleteModal: false })}
                            onDelete={this.handleDeleteDiningLocation}
                        />
                    </Modal>
                </form>

            </>
        )
    }
}

function mapStateToProps(state) {
    const categoryData = (state.categoryReducer && state.categoryReducer.categoryData) ? state.categoryReducer.categoryData : [];



    return {
        categoryData,
    }
};

export default connect(mapStateToProps, {AddDiningLocation, UpdateDiningLocation, DeleteDiningLocation})(reduxForm({
    form: 'DiningLocationForm',
    validate,
    enableReinitialize: true,
})(AddEditDiningLocation));
